Array.prototype.Contains = function(item)
{
  for (var i = 0; i < this.length; i++)
  {
    if (this[i] == item)
      return true;
  }
  return false;
}

Array.prototype.contains = function(item)
{
  for (var i = 0; i < this.length; i++)
  {
    if (this[i] == item)
      return true;
  }
  return false;
}

Array.prototype.findFirst = function(item)
{
  for (var i = 0; i < this.length; i++)
  {
    if (this[i] == item)
      return this[i];
  }
  return null;
}

Array.prototype.intersection = function(array)
{
  var result = new Array();
  for (var i = 0; i < array.length; i++)
  {
    var item = array[i];
    if (this.contains(item))
      result.push(item); ;
  }
  return result;
}
Array.prototype.exclude = function(array)
{
  var result = new Array();
  for (var i = 0; i < this.length; i++)
  {
    var item = this[i];
    if (!array.contains(item))
      result.push(item); ;
  }
  return result;
}


Array.prototype.remove = function(elem)
{
  var index = this.indexOf(elem);

  if (index !== -1)
  {
    this.splice(index, 1);
  }
};
